<template>
  <div class="relative w-full">
    <wegow-input
      :id="idInput"
      :value="searchQuery"
      :icon-alt="$t('wegow.iconAltSearch')"
      class="w-full placeholder:text-color-white placeholder-opacity-100"
      label-for="query"
      :placeholder="$t('general.forms.inputSearchPlaceholder')"
      placeholder-color="text-color-white"
      background-input="bg-transparent"
      border-input="border-white"
      :border-radius="
        recomendations && openSearch && searchQuery.length > 0
          ? 'medium'
          : 'all'
      "
      :icon="require('@/assets/images/ic-advance-search.svg')"
      :border-icon="true"
      :padding="topNavbar ? 'py-2 pl-4' : 'p-1 pl-4'"
      @focus="openSearchMethod(true)"
      @focusout="openSearchMethod(false)"
      @update:value="search($event)"
      @enter="
        openSearch = false;
        opening = false;
        goToSearch({});
      "
      @click-icon="
        openSearch = false;
        opening = false;
        goToSearch({});
      "
    />
    <div
      v-if="recomendations && openSearch && searchQuery.length > 0"
      ref="dropdownSearchRef"
      class="absolute w-full search-options"
    >
      <div class="flex flex-wrap tags mb-2">
        <span
          class="mt-2 mb-2"
          :class="searchTypes.includes(8) ? 'selected' : ''"
          @click="addType(8)"
          >{{ $t("wegow.filters.concerts") }}</span
        >
        <span
          class="mt-2 mb-2"
          :class="searchTypes.includes(9) ? 'selected' : ''"
          @click="addType(9)"
          >{{ $t("wegow.filters.festivals") }}</span
        >
        <span
          class="mt-2 mb-2"
          :class="searchTypes.includes(0) ? 'selected' : ''"
          @click="addType(0)"
          >{{ $t("wegow.filters.artists") }}</span
        >
        <span
          class="mt-2 mb-2"
          :class="searchTypes.includes(2) ? 'selected' : ''"
          @click="addType(2)"
          >{{ $t("wegow.filters.venues") }}</span
        >
        <span
          v-if="isAuth"
          class="mt-2 mb-2"
          :class="searchTypes.includes(3) ? 'selected' : ''"
          @click="addType(3)"
          >{{ $t("wegow.filters.people") }}</span
        >
      </div>
      <div
        v-for="option in loadingResults ? [] : searchOptions"
        :key="option.id + '-option'"
        class="flex flex-col cursor-pointer search-option"
        @click="goToSearch(option)"
      >
        {{ getName(option) }}
        <span v-if="option.doc_type === 3" class="text-color-gray text-[10px]">
          @{{ option.extra.slug }}
        </span>
      </div>
      <div v-if="searchOptions.length === 0 && !loadingResults">
        {{ $t("wegow.filters.noResults") }}
      </div>
      <div v-else-if="loadingResults">
        <wegow-loader />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useGeneral } from "@/composables/useGeneral";

import WegowInput from "@/components/general/forms/WegowInput";
import WegowLoader from "@/components/general/ui/WegowLoader";

import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useUser } from "@/composables/useUser";
import { useI18n } from "vue-i18n";
import useDetectOutsideClick from "@/plugins/useDetectOutsideClick";

const route = useRoute();
const router = useRouter();
const { isAuth } = useUser();
const i18n = useI18n();

const { footerInfo, searchOptions, getSuggestions } = useGeneral();

const props = defineProps({
  recomendations: {
    type: Boolean,
    default: true
  },
  topNavbar: {
    type: Boolean,
    default: false
  },
  idInput: {
    type: String,
    default: "search-input"
  }
});

const searchQuery = ref("");
const searchTypes = ref([0, 2, 8, 9]);
const openSearch = ref(false);
let debounce = null;
const dropdownSearchRef = ref();
const opening = ref(false);
const loadingResults = ref(false);
const isFocus = ref(false);

onMounted(() => {
  if (route.path.includes("/geo/") && route.query.query) {
    searchQuery.value = route.query.query;
  }
});

const openSearchMethod = isFocusInput => {
  isFocus.value = isFocusInput;
  opening.value = false;
  openSearch.value = true;
  setTimeout(() => {
    opening.value = true;
  }, 250);
};

const addType = type => {
  if (searchTypes.value.includes(type) && searchTypes.value.length > 1) {
    let index = searchTypes.value.indexOf(type);
    searchTypes.value.splice(index, 1);
    search(searchQuery.value);
  } else if (!searchTypes.value.includes(type)) {
    switchControlTypes(type);
    search(searchQuery.value);
  }
};

const getName = option => {
  if (option.doc_type === 1) {
    return option["name_" + i18n.locale.value || "es"];
  } else {
    return option.name;
  }
};
const switchControlTypes = type => {
  if (type === 3) {
    searchTypes.value = [type];
  } else {
    if (searchTypes.value[0] === 3) {
      searchTypes.value = [type];
    } else {
      searchTypes.value.push(type);
    }
  }
};

const getType = option => {
  switch (option.doc_type) {
    case 0:
      return "artists";
    case 2:
      return "venues";
    case 3:
      return "users";
    case 8:
      return "concerts";
    case 9:
      return "festivals";
    default:
      return "both";
  }
};

const search = $event => {
  searchQuery.value = $event;
  if (props.recomendations) {
    loadingResults.value = true;
    if (debounce) clearTimeout(debounce);
    if ($event.length >= 3) {
      debounce = setTimeout(async () => {
        await getSuggestions({
          types: searchTypes.value.join(","),
          query: searchQuery.value
        });
        loadingResults.value = false;
      }, 350);
    }
  }
};

const goToSearch = option => {
  let searchQueryParams = {};
  if (option.id) {
    // TODO: se puede cambiar id por otra cosa, que id realmente no se llega a usar y podria ser doc_type, que esta siempre
    searchQuery.value = getName(option);
    searchQueryParams = {
      query: searchQuery.value,
      type: getType(option)
    };
  } else if (searchTypes.value.length === 1) {
    let doc_type = {};
    doc_type.doc_type = searchTypes.value[0];
    searchQueryParams = {
      query: searchQuery.value,
      type: getType(doc_type)
    };
  } else {
    searchQueryParams = {
      query: searchQuery.value,
      type: getType({})
    };
  }
  if (route.path.includes("/geo/")) {
    router
      .push({
        path: route.path,
        query: { ...route.params, ...searchQueryParams }
      })
      .catch(error => {
        console.error(error);
      });
  } else {
    router.push({
      name: "FiltersPageCountry",
      params: {
        region: route.params.region || "es",
        type: footerInfo.value?.links?.filter.split("/")[4] || "conciertos",
        country: footerInfo.value?.country_slug || "espana"
      },
      query: { ...searchQueryParams }
    });
  }
  openSearch.value = false;
};

useDetectOutsideClick(dropdownSearchRef, () => {
  if (opening.value) {
    opening.value = false;
    if (!isFocus.value) {
      openSearch.value = false;
      goToSearch({});
    }
  }
});
</script>

<style lang="scss" scoped>
.search-options {
  margin-top: -1px;
  background-color: $backgroundBlack;
  border: 1px solid white;
  padding-bottom: 18px;
  // padding-top: 9px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  max-height: 50vh;
  overflow-y: auto;
  // input {
  //   ::placeholder {
  //     color: white;
  //   }
  // }
  & > div {
    padding-left: 18px;
    margin-bottom: 10px;
    &.search-option:hover {
      background-color: $backgroundGrey;
    }
  }
  .tags {
    position: sticky;
    top: 0;
    background-color: #000214;
    padding-top: 9px;
    & > span {
      border: 1px solid $inputLigthBackground;
      color: $inputLigthBackground;
      border-radius: 5px;
      margin-right: 10px;
      min-width: 90px;
      text-align: center;
      padding: 1px 10px;
      cursor: pointer;
      &.selected {
        border-color: $topaz;
        color: $topaz;
      }
    }
  }
  @media screen and (max-width: $screen-md) {
    width: -webkit-fill-available;
    max-height: 75vh;
  }
}
</style>
